import { Phone, Truck, FileCheck2, Recycle } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { PHONE_DISPLAY, PHONE_TEL } from "../constants/content";

const IMG =
    "https://images.unsplash.com/photo-1770068511814-f9560e7d2991?crop=entropy&cs=srgb&fm=jpg&q=85";

const POINTS = [
    { icon: Truck, text: "Free flatbed towing from any location in Toronto & the GTA" },
    { icon: FileCheck2, text: "All ownership paperwork handled for you, start to finish" },
    { icon: Recycle, text: "Responsibly recycled — less waste, more cash in your pocket" },
];

export const Editorial = ({ cityName = "Toronto" }) => (
    <section className="relative bg-white noise-overlay overflow-hidden">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 lg:py-32 grid gap-14 lg:grid-cols-2 lg:items-center">
            <Reveal>
                <Eyebrow>Junk &amp; scrap car removal in {cityName}</Eyebrow>
                <h2 className="mt-4 font-display font-extrabold uppercase tracking-tight text-2xl sm:text-3xl lg:text-4xl text-[#141721] leading-tight">
                    Running or not,{" "}
                    <span className="text-[#FF3B30]">we pay cash on the spot.</span>
                </h2>
                <p className="mt-6 text-base text-[#565B6B] leading-relaxed max-w-xl">
                    At Toronto Scrap Car Removal, we buy vehicles in any condition — dead on the
                    driveway, written off in an accident, or simply taking up space in the garage.
                    Our local team evaluates your car&apos;s make and model to make sure you get
                    fair market value, then takes care of everything from pick-up in {cityName} to
                    disposal.
                </p>
                <ul className="mt-8 space-y-4">
                    {POINTS.map((p) => (
                        <li key={p.text} className="flex items-start gap-4">
                            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-[#F4F4F2] border border-[#E3E3DE]">
                                <p.icon className="h-[18px] w-[18px] text-[#FF3B30]" strokeWidth={2} />
                            </span>
                            <span className="text-sm text-[#565B6B] leading-relaxed pt-1.5">{p.text}</span>
                        </li>
                    ))}
                </ul>
                <a
                    href={PHONE_TEL}
                    data-testid="editorial-call-btn"
                    className="mt-10 inline-flex items-center gap-3 rounded-md bg-[#FF3B30] px-7 py-3.5 font-display font-bold text-base text-white uppercase tracking-wide transition-all duration-300 hover:bg-[#E0342B] hover:-translate-y-0.5"
                >
                    <Phone className="h-5 w-5" strokeWidth={2.6} />
                    Call {PHONE_DISPLAY}
                </a>
            </Reveal>

            <Reveal delay={0.15}>
                <div className="relative">
                    <div className="absolute -inset-3 rounded-lg border border-[#FF3B30]/40 translate-x-4 translate-y-4" />
                    <div className="relative overflow-hidden rounded-lg" style={{ clipPath: "polygon(0 0, 100% 0, 100% 88%, 88% 100%, 0 100%)" }}>
                        <img
                            src={IMG}
                            alt={`Scrap cars collected from ${cityName} at an auto recycling yard`}
                            className="w-full h-[420px] lg:h-[520px] object-cover transition-transform duration-700 hover:scale-105"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-white/70 via-transparent to-transparent" />
                    </div>
                    <div className="absolute bottom-6 left-6 rounded-md bg-white/85 backdrop-blur-md border border-[#E3E3DE] px-5 py-3">
                        <span className="font-mono-ind text-[11px] uppercase tracking-widest text-[#FF3B30]">
                            Free towing · Same-day pickup
                        </span>
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);
